import { render, staticRenderFns } from "./BulkShowEchange.vue?vue&type=template&id=da807a70&scoped=true&"
import script from "./BulkShowEchange.vue?vue&type=script&lang=js&"
export * from "./BulkShowEchange.vue?vue&type=script&lang=js&"
import style0 from "./BulkShowEchange.vue?vue&type=style&index=0&id=da807a70&lang=scss&scoped=true&"
import style1 from "./BulkShowEchange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da807a70",
  null
  
)

export default component.exports